// src/context/ErrorBridge.ts
let globalSetError: ((obj: any) => void) | null = null;

export const setErrorRef = (setError: (msg: any) => void) => {
  globalSetError = setError;
};

export const triggerGlobalNotifications = (obj: any) => {
  if (globalSetError) {
    globalSetError(obj);
  } else {
    console.error("[ErrorBridge] setError not initialized");
  }
};
